module.exports = __webpack_public_path__ + "static/img/copy_icon.b5bb67e5.svg";